import { API_BASE } from "../api";

const normalizeUrl = (value) => String(value || "").trim();
const DEFAULT_PLACEHOLDER = "/logos/default-item.jpg";

function getHostname(value) {
  try {
    return String(new URL(value).hostname || "").toLowerCase();
  } catch {
    return "";
  }
}

function isRelativeUrl(value) {
  return /^\/(?!\/)/.test(String(value || "").trim());
}

function isFirstPartyImageUrl(value) {
  const url = normalizeUrl(value);
  if (!url || isRelativeUrl(url)) return true;
  try {
    const parsed = new URL(url);
    const apiHost = getHostname(API_BASE);
    const appHost = String(window.location.hostname || "").toLowerCase();
    const host = String(parsed.hostname || "").toLowerCase();
    return host === apiHost || host === appHost;
  } catch {
    return false;
  }
}

export function isRestrictedImageUrl(value) {
  const url = normalizeUrl(value);
  if (!url) return false;
  return !isFirstPartyImageUrl(url) && /^https?:\/\//i.test(url);
}

export function toDisplayImageUrl(value) {
  const url = normalizeUrl(value);
  if (!url) return "";
  if (isFirstPartyImageUrl(url)) return url;
  if (!/^https?:\/\//i.test(url)) return "";
  return `${API_BASE.replace(/\/+$/, "")}/api/image-proxy?url=${encodeURIComponent(url)}`;
}

export function getDisplayImageUrl(itemOrUrl, placeholderSrc = DEFAULT_PLACEHOLDER) {
  const rawUrl = typeof itemOrUrl === "string"
    ? itemOrUrl
    : itemOrUrl?.image_url || itemOrUrl?.ref_image_url || "";
  return toDisplayImageUrl(rawUrl) || placeholderSrc;
}

export function buildImageCandidates(urls, placeholderSrc = DEFAULT_PLACEHOLDER) {
  const seen = new Set();
  const out = [];

  for (const raw of Array.isArray(urls) ? urls : [urls]) {
    const resolved = toDisplayImageUrl(raw);
    if (!resolved || seen.has(resolved)) continue;
    seen.add(resolved);
    out.push(resolved);
  }

  const placeholder = normalizeUrl(placeholderSrc) || DEFAULT_PLACEHOLDER;
  if (!seen.has(placeholder)) out.push(placeholder);
  return out;
}
